export const gameCategories = [
  {
    slug: 'jingdian-mahjong',
    name: '经典麻将',
    shortDesc: '最纯正的传统麻将玩法，四人成局，吃碰杠胡，体验原汁原味的国粹魅力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20mahjong%20tiles%20on%20a%20dark%20wooden%20table%2C%20four%20players%20arrangement%2C%20warm%20ambient%20lighting%2C%20elegant%20and%20classic%20aesthetic%2C%20top-down%20view%2C%20rich%20textures%20of%20ivory%20tiles%20with%20Chinese%20characters%2C%20professional%20product%20photography&width=800&height=400&seq=jingdian-mahjong&orientation=landscape',
    description: '经典麻将是流传最广的麻将玩法，遵循传统四人麻将规则。玩家通过摸牌、吃牌、碰牌、杠牌等方式组合手牌，最终以胡牌决出胜负。经典麻将电脑版在线玩完美还原线下麻将的真实体验，让您在电脑前也能感受到搓麻的乐趣。',
    rules: [
      '四人参与，使用136张标准麻将牌（万、条、筒、字牌）',
      '庄家起手14张牌，闲家13张牌',
      '可以进行吃、碰、杠操作',
      '胡牌需满足基本牌型，如平胡、对对胡、清一色等',
      '每种胡牌牌型对应不同番数'
    ],
    features: ['经典规则', '番型完整', '界面简洁', '流畅操作'],
  },
  {
    slug: 'xueliu-chenghe',
    name: '血流成河',
    shortDesc: '紧张刺激的四川麻将变体，血战到底的升级版，胡牌后仍可继续，直到牌墙摸完。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Sichuan%20style%20mahjong%20game%20scene%20with%20vibrant%20red%20accents%2C%20dramatic%20lighting%2C%20multiple%20winning%20tiles%20arranged%20on%20a%20dark%20table%2C%20Chinese%20traditional%20patterns%20in%20background%2C%20exciting%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20photography&width=800&height=400&seq=xueliu-chenghe&orientation=landscape',
    description: '血流成河是四川地区流行的麻将玩法，在血战到底的基础上增加了胡牌后继续摸打的规则。即使已经胡牌，仍然可以继续参与对局，胡牌越多赢得越多，不到最后一刻胜负难料，极具戏剧性和趣味性。',
    rules: [
      '去掉字牌和风牌，只使用万、条、筒共108张牌',
      '缺一门才能胡牌',
      '胡牌后可继续摸打，直到牌墙摸完',
      '一局可能胡多次牌',
      '以最终总分决定输赢'
    ],
    features: ['胡牌继续', '紧张刺激', '四川特色', '翻盘机会'],
  },
  {
    slug: 'guangdong-mahjong',
    name: '广东麻将',
    shortDesc: '广受欢迎的粤式麻将玩法，鸡胡平胡任你选，节奏明快，深受华南地区玩家喜爱。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cantonese%20style%20mahjong%20setup%20with%20elegant%20jade-green%20tiles%2C%20traditional%20Guangdong%20tea%20set%20beside%20the%20table%2C%20warm%20natural%20light%20from%20window%2C%20refined%20and%20cultural%20atmosphere%2C%20professional%20product%20photography%2C%20clean%20composition&width=800&height=400&seq=guangdong-mahjong&orientation=landscape',
    description: '广东麻将是粤港澳地区最受欢迎的麻将玩法，以其独特的计番规则和灵活多变的打法著称。广东麻将电脑版在线玩支持鸡胡、平胡等多种胡牌方式，让您感受最地道的粤式麻将文化。',
    rules: [
      '使用136张标准麻将牌',
      '支持鸡胡（最基础胡牌）和平胡',
      '吃、碰、杠操作灵活',
      '番种丰富，包括混一色、对对胡、十三幺等',
      '注重防守策略'
    ],
    features: ['粤式规则', '鸡胡平胡', '番种丰富', '策略性强'],
  },
  {
    slug: 'guobiao-mahjong',
    name: '国标麻将',
    shortDesc: '国家体育总局认证的竞技麻将规则，81个番种，适合追求技巧与策略的高水平玩家。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20competitive%20mahjong%20setup%20with%20all%20144%20tiles%20including%20flower%20tiles%2C%20official%20tournament%20style%20arrangement%2C%20clean%20modern%20aesthetic%2C%20bright%20even%20lighting%2C%20professional%20sports%20photography%2C%20minimal%20background&width=800&height=400&seq=guobiao-mahjong&orientation=landscape',
    description: '国标麻将是由国家体育总局在1998年颁布的竞技麻将规则，包含81个番种，是麻将运动标准化、竞技化的重要成果。国标麻将电脑版在线玩严格遵循官方规则，是麻将竞技爱好者的最佳选择。',
    rules: [
      '使用144张牌（含春夏秋冬、梅兰竹菊8张花牌）',
      '必须达到8番才能胡牌',
      '81个官方番种，如大三元、小四喜、九莲宝灯等',
      '不重复计算原则',
      '竞技性强，减少运气成分'
    ],
    features: ['81番种', '国家认证', '竞技性强', '策略至上'],
  },
  {
    slug: 'changsha-mahjong',
    name: '长沙麻将',
    shortDesc: '湘味十足的湖南特色麻将，二五八做将、扎鸟玩法，独树一帜的地方麻将经典。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hunan%20Changsha%20style%20mahjong%20with%20warm%20spicy%20tones%2C%20red%20chili%20decorative%20elements%2C%20traditional%20Chinese%20wooden%20table%2C%20cozy%20atmosphere%2C%20regional%20Chinese%20cultural%20vibe%2C%20professional%20photography%2C%20rich%20textures&width=800&height=400&seq=changsha-mahjong&orientation=landscape',
    description: '长沙麻将是湖南长沙地区的特色麻将玩法，以独特的"二五八做将"规则和"扎鸟"玩法著称。长沙麻将电脑版在线玩让您在电脑上也能体验地道的湖南麻将乐趣。',
    rules: [
      '使用108张牌（万、条、筒）',
      '必须以二、五、八作为将牌',
      '扎鸟：胡牌后随机翻一张牌决定额外输赢',
      '支持自摸和点炮',
      '可以吃、碰、杠'
    ],
    features: ['二五八将', '扎鸟玩法', '湖南特色', '节奏明快'],
  },
  {
    slug: 'single-player',
    name: '单机版麻将',
    shortDesc: '无需联网，随时随地与电脑AI对战，适合练习牌技和休闲娱乐的麻将单机版电脑游戏。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20computer%20screen%20displaying%20mahjong%20game%20interface%2C%20minimalist%20desk%20setup%2C%20soft%20warm%20lighting%2C%20AI%20opponent%20concept%2C%20digital%20yet%20traditional%2C%20professional%20UI%20photography%2C%20clean%20composition&width=800&height=400&seq=single-player&orientation=landscape',
    description: '麻将单机版电脑是专为练习和休闲设计的麻将游戏模式。无需联网，即可与智能AI进行对战。AI难度可调节，从新手到高手都能找到适合自己的挑战。麻将单机版电脑是您提升牌技的绝佳工具。',
    rules: [
      '无需网络连接，打开即玩',
      'AI智能对手，难度可调节',
      '支持多种麻将规则切换',
      '可随时暂停和继续',
      '内置提示和撤销功能'
    ],
    features: ['无需联网', 'AI对战', '难度可调', '随时暂停'],
  }
];

export const articles = [
  {
    slug: 'mahjong-beginner-guide',
    title: '麻将新手入门指南：从零开始学打麻将',
    excerpt: '从未接触过麻将？不用担心！这篇麻将新手入门指南将带你从认识麻将牌开始，一步步掌握基本规则和胡牌技巧，让你快速上手享受麻将乐趣。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20of%20mahjong%20tiles%20being%20arranged%20by%20a%20beginner%2C%20color-coded%20tiles%20with%20labels%2C%20educational%20atmosphere%2C%20warm%20lighting%2C%20clean%20white%20background%20with%20subtle%20textures%2C%20professional%20photography&width=800&height=400&seq=beginner-guide&orientation=landscape',
    content: `
      <h2>认识麻将牌</h2>
      <p>一副标准麻将牌共有136张，分为以下几类：</p>
      <ul>
        <li><strong>万子（36张）：</strong>一万到九万，每种4张</li>
        <li><strong>条子（36张）：</strong>一条到九条，每种4张</li>
        <li><strong>筒子（36张）：</strong>一筒到九筒，每种4张</li>
        <li><strong>字牌（28张）：</strong>东南西北中发白，每种4张</li>
      </ul>
      <p>此外，部分玩法还会加入8张花牌（春夏秋冬、梅兰竹菊）。</p>

      <h2>基本规则</h2>
      <p>麻将通常由4人参与，每人起始13张牌（庄家14张）。游戏目标是率先将手牌组成特定的组合牌型，即"胡牌"。</p>
      <p>每轮基本流程：摸牌 → 出牌 → 下家摸牌 → 出牌，循环进行。</p>

      <h2>基本操作</h2>
      <ul>
        <li><strong>吃牌：</strong>上家出牌后，如果你手中有两张牌可以与这张牌组成顺子，可以选择吃牌</li>
        <li><strong>碰牌：</strong>任意玩家出牌后，如果你手中有两张相同的牌，可以选择碰牌组成刻子</li>
        <li><strong>杠牌：</strong>手中有三张相同牌时，其他玩家打出第四张可明杠；自己摸到第四张可暗杠</li>
        <li><strong>胡牌：</strong>手牌满足特定组合时即可胡牌获胜</li>
      </ul>

      <h2>常见胡牌牌型</h2>
      <ul>
        <li><strong>平胡：</strong>最基础的胡牌方式，由四组顺子或刻子加一对将牌组成</li>
        <li><strong>对对胡：</strong>全部由刻子（或杠）加一对将牌组成</li>
        <li><strong>清一色：</strong>全部由同一种花色组成</li>
        <li><strong>混一色：</strong>由一种花色加字牌组成</li>
        <li><strong>七对：</strong>由七个对子组成</li>
      </ul>

      <h2>推荐从哪种玩法开始？</h2>
      <p>对于新手玩家，我们推荐从经典麻将开始。经典麻将规则最为普及，学会之后可以轻松过渡到其他玩法。使用麻将电脑版在线玩，您可以先选择单机模式与AI对战，在无压力的环境中练习基本操作和牌型组合。</p>
      <p>当您熟悉基本规则后，可以尝试四川血流成河或广东麻将等更具地方特色的玩法，逐步拓展麻将技艺。</p>
    `,
    category: '攻略教程',
  },
  {
    slug: 'xueliu-chenghe-strategy',
    title: '血流成河高级策略：如何在胡牌后继续扩大优势',
    excerpt: '血流成河的独特之处在于胡牌后仍可继续游戏。本文分享如何在胡牌后保持竞争力，利用残局扩大优势，成为血流成河的真正高手。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Strategic%20mahjong%20gameplay%20scene%20with%20a%20player%20thoughtfully%20arranging%20tiles%2C%20multiple%20win%20markers%20visible%2C%20dark%20green%20felt%20table%2C%20dramatic%20side%20lighting%2C%20intense%20focus%2C%20professional%20photography&width=800&height=400&seq=xueliu-strategy&orientation=landscape',
    content: `
      <h2>血流成河与传统麻将的核心区别</h2>
      <p>血流成河最大的特点是：即使已经胡牌，你仍然可以继续摸牌和出牌。这意味着在血流成河中，不存在"一胡定胜负"的情况。一局游戏中，你可能胡牌多次，也可能胡了一次后反而被对手反超。</p>

      <h2>前期策略：优先胡牌</h2>
      <p>在血流成河的前期阶段，优先完成第一次胡牌非常重要。原因如下：</p>
      <ul>
        <li>第一次胡牌获得基础分数，确立了正收益</li>
        <li>胡牌后心态更加放松，可以更好地进行后续决策</li>
        <li>给对手造成心理压力</li>
      </ul>

      <h2>中期策略：控制节奏</h2>
      <p>完成第一次胡牌后，你需要改变策略思路：</p>
      <ul>
        <li>不要急于追求第二次胡牌，先观察牌墙剩余数量</li>
        <li>注意分析对手的手牌类型，预判他们的胡牌方向</li>
        <li>合理使用吃碰杠操作，干扰对手的节奏</li>
      </ul>

      <h2>残局策略：锁定胜局</h2>
      <p>当牌墙剩余不足20张时，进入残局阶段：</p>
      <ul>
        <li>如果分数领先，采取保守策略，避免放炮</li>
        <li>如果分数落后，积极追求高番值牌型</li>
        <li>密切关注已打出的牌，提高判断准确率</li>
      </ul>

      <h2>常见误区</h2>
      <ul>
        <li>误区一：胡牌后就放松警惕——这是最致命的错误</li>
        <li>误区二：过分追求大牌——在血流成河中，频率比大小更重要</li>
        <li>误区三：忽视防守——即使你已胡牌，也要防止对手通过你的出牌胡牌</li>
      </ul>
    `,
    category: '攻略教程',
  },
  {
    slug: 'guangdong-mahjong-fanshu',
    title: '广东麻将番数计算全攻略：从鸡胡到大四喜',
    excerpt: '广东麻将的魅力在于丰富的番种体系。本文详细解读广东麻将所有常见番种及其计算方法，让你在粤式麻将桌上游刃有余。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Detailed%20mahjong%20scoring%20chart%20with%20Cantonese%20style%20elements%2C%20elegant%20calligraphy%20notations%2C%20traditional%20Chinese%20aesthetic%2C%20jade%20and%20gold%20color%20scheme%2C%20educational%20reference%20design%2C%20clean%20layout%2C%20professional%20photography&width=800&height=400&seq=guangdong-fanshu&orientation=landscape',
    content: `
      <h2>广东麻将番种体系概述</h2>
      <p>广东麻将的番种体系非常丰富，从最简单的鸡胡（一番）到最高的大四喜（十三番），涵盖了数十种不同的组合方式。了解番种计算是掌握广东麻将的关键。</p>

      <h2>一番番种</h2>
      <ul>
        <li><strong>鸡胡：</strong>最基础的胡牌，没有特殊组合</li>
        <li><strong>自摸：</strong>自己摸到胡牌的那张牌</li>
        <li><strong>无花：</strong>手中没有花牌</li>
      </ul>

      <h2>二到三番番种</h2>
      <ul>
        <li><strong>平胡：</strong>全部由顺子组成，没有碰和杠</li>
        <li><strong>混一色：</strong>由一种花色加字牌组成</li>
        <li><strong>对对胡：</strong>全部由刻子或杠组成</li>
        <li><strong>半清：</strong>由一种花色加风牌组成</li>
      </ul>

      <h2>五番以上番种</h2>
      <ul>
        <li><strong>清一色（五番）：</strong>全部由同一种花色组成</li>
        <li><strong>混幺九（五番）：</strong>全部由幺九牌（一万九万、一条九条、一筒九筒）加字牌组成</li>
      </ul>

      <h2>八番以上高番种</h2>
      <ul>
        <li><strong>小三元（八番）：</strong>中发白中有两刻加一对将</li>
        <li><strong>大三元（十番）：</strong>中发白全部为刻子或杠</li>
        <li><strong>小四喜（十番）：</strong>东南西北中有三刻加一对将</li>
        <li><strong>大四喜（十三番）：</strong>东南西北全部为刻子或杠</li>
      </ul>

      <h2>番数计算注意事项</h2>
      <p>在广东麻将中，番数是累加的。例如，自摸的混一色就是1番（自摸）+ 3番（混一色）= 4番。理解番种的组合关系，才能在实战中做出最优决策。</p>
    `,
    category: '麻将知识',
  },
  {
    slug: 'guobiao-mahjong-tournament',
    title: '国标麻将竞技指南：81番种速记与实战应用',
    excerpt: '国标麻将81个番种太多记不住？本文提供分类记忆法和实战中最高频使用的番种清单，帮助你在竞技麻将中快速成长为高手。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20mahjong%20tournament%20scene%20with%20numbered%20tables%2C%20official%20Mahjong%20Competition%20Rules%20book%20visible%2C%20bright%20arena%20lighting%2C%20serious%20competitive%20atmosphere%2C%20professional%20sports%20photography&width=800&height=400&seq=guobiao-tournament&orientation=landscape',
    content: `
      <h2>国标麻将番种分类</h2>
      <p>国标麻将共有81个番种，按分值分为12个等级：1分、2分、4分、6分、8分、12分、16分、24分、32分、48分、64分、88分。记住所有番种看似困难，但通过合理分类，记忆并不复杂。</p>

      <h2>高频使用的低分番种（1-4分）</h2>
      <p>这些番种在实战中出现频率最高，是国标麻将的基础：</p>
      <ul>
        <li>无字（1分）：手中没有字牌</li>
        <li>平和（2分）：由四组顺子加一对非字牌将组成</li>
        <li>喜相逢（1分）：两种花色有相同的顺子组合</li>
        <li>连六（1分）：同花色连续六张序数牌</li>
      </ul>

      <h2>中分番种（6-16分）</h2>
      <p>这些番种是高分牌型的基础：</p>
      <ul>
        <li>全带幺（6分）：每组牌都包含幺九牌</li>
        <li>不求人（8分）：没有吃碰杠，且自摸胡牌</li>
        <li>清龙（16分）：同花色一至九各一张</li>
        <li>三色双龙会（16分）：万条筒各有1-2-3和7-8-9顺子</li>
      </ul>

      <h2>高分番种（24-88分）</h2>
      <p>这些番种一旦成功组成，基本锁定胜局：</p>
      <ul>
        <li>七对（24分）：七个对子</li>
        <li>清一色（24分）：全部同花色</li>
        <li>小三元（64分）：中发白中有两刻一将</li>
        <li>大三元（88分）：中发白全部为刻子</li>
        <li>九莲宝灯（88分）：同花色1112345678999的牌型</li>
      </ul>

      <h2>实战策略</h2>
      <p>在国标麻将中，必须达到8番才能胡牌。因此，你需要从发牌开始就规划番种组合。建议初期以2-4分的常见番种为基础，逐步叠加到8番以上，而不是贪图高分番种。</p>
    `,
    category: '麻将知识',
  },
  {
    slug: 'multiplayer-mahjong-tips',
    title: '麻将多人联机电脑版：线上对战的礼仪与技巧',
    excerpt: '从线下转到线上，麻将的社交属性依然重要。了解多人联机麻将的礼仪规范和实战技巧，让你的在线麻将体验更加愉快。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Multiple%20people%20enjoying%20online%20mahjong%20together%20on%20their%20computers%2C%20split%20screen%20concept%2C%20warm%20social%20atmosphere%2C%20modern%20home%20office%20settings%2C%20friendly%20competition%2C%20professional%20lifestyle%20photography&width=800&height=400&seq=multiplayer-tips&orientation=landscape',
    content: `
      <h2>线上麻将的基本礼仪</h2>
      <p>虽然是在线对战，但基本的麻将礼仪同样重要：</p>
      <ul>
        <li>进入房间后主动打招呼</li>
        <li>不要在出牌时故意拖延时间</li>
        <li>输赢都保持礼貌，不使用不文明语言</li>
        <li>遵守房间规则，不恶意退出</li>
      </ul>

      <h2>线上对战的特殊技巧</h2>
      <p>麻将多人联机电脑版与线下麻将有一些不同之处：</p>
      <ul>
        <li>利用出牌时间观察已打出的牌，做好笔记</li>
        <li>注意对手的出牌速度变化，这可能暗示他们的手牌状态</li>
        <li>善用游戏内置的表情和快捷语进行交流</li>
        <li>保持网络稳定，避免掉线影响游戏体验</li>
      </ul>

      <h2>选择合适的房间</h2>
      <p>麻将电脑版在线玩提供多种房型选择：</p>
      <ul>
        <li>新手房：适合初学者，节奏较慢</li>
        <li>普通房：标准规则，适合大多数玩家</li>
        <li>高手房：高水平对局，竞技性强</li>
        <li>好友房：可以邀请好友一起玩</li>
      </ul>
    `,
    category: '攻略教程',
  },
  {
    slug: 'mahjong-health-benefits',
    title: '打麻将的五大健康益处：不只是娱乐',
    excerpt: '你也许不知道，适度打麻将对身心健康有诸多益处。从锻炼大脑到社交维系，麻将远不止是一种消遣方式。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20and%20healthy%20lifestyle%20scene%20with%20mahjong%20elements%2C%20senior%20friends%20smiling%20around%20a%20table%2C%20natural%20daylight%2C%20plants%20and%20tea%20in%20the%20background%2C%20positive%20and%20joyful%20atmosphere%2C%20professional%20lifestyle%20photography&width=800&height=400&seq=health-benefits&orientation=landscape',
    content: `
      <h2>1. 锻炼大脑，预防认知衰退</h2>
      <p>麻将需要记忆、计算、判断和策略规划等多种认知能力的参与。研究表明，经常打麻将的老年人患阿尔茨海默病的风险显著降低。麻将中的牌型组合和概率计算是绝佳的脑力训练。</p>

      <h2>2. 提升社交互动质量</h2>
      <p>麻将是一种社交性极强的游戏。在麻将桌上，玩家之间需要交流、互动、协作甚至"勾心斗角"，这有助于维系社交关系，减轻孤独感。麻将电脑版在线玩的多人联机功能让远在天边的朋友也能一起享受麻将的社交乐趣。</p>

      <h2>3. 培养专注力和耐心</h2>
      <p>一局麻将通常持续15-30分钟，需要持续的注意力和耐心。长期打麻将能够有效提升专注力，这对于现代人来说是非常宝贵的能力。</p>

      <h2>4. 锻炼情绪管理能力</h2>
      <p>麻将中有输有赢，运气与策略交织。学会在好牌时保持冷静，在烂牌时不急躁，这种情绪管理能力可以迁移到生活和工作中。</p>

      <h2>5. 促进手眼协调</h2>
      <p>摸牌、理牌、出牌的过程需要精细的手部动作和视觉配合。对于中老年人来说，这是维持手眼协调能力的好方法。</p>

      <h2>温馨提示</h2>
      <p>虽然打麻将好处多多，但也要注意适度。建议每次游戏控制在1-2小时以内，每隔30分钟起身活动一下。麻将电脑版在线玩内置了健康提醒功能，帮助玩家养成良好的游戏习惯。</p>
    `,
    category: '麻将文化',
  }
];

export const faqItems = [
  {
    question: '麻将电脑版在线玩需要下载安装吗？',
    answer: '完全不需要！麻将电脑版在线玩是基于浏览器的网页麻将游戏，您只需要打开浏览器访问我们的网站，即可立即开始游戏。无需下载任何软件或插件，省去了安装和更新的麻烦。这也是"麻将电脑版在线玩"最大的优势之一。'
  },
  {
    question: '支持哪些麻将玩法？',
    answer: '我们支持多种主流麻将玩法，包括经典麻将、血流成河、广东麻将、国标麻将、长沙麻将等。每种玩法都有独立的规则说明和新手引导，让您快速上手。'
  },
  {
    question: '可以和朋友一起玩吗？',
    answer: '当然可以！麻将电脑版在线玩支持多人联机模式。您可以创建私人房间邀请好友加入，也可以加入公开房间与世界各地的麻将爱好者切磋技艺。多人联机让麻将的社交乐趣不受地理限制。'
  },
  {
    question: '单机版和联机版有什么区别？',
    answer: '麻将单机版电脑适合练习和休闲，由AI作为对手，无需网络，随时随地可玩。联机版则是与真实玩家对战，社交性和竞技性更强。您可以根据自己的需求自由切换。'
  },
  {
    question: '游戏是完全免费的吗？',
    answer: '是的！麻将电脑版在线玩的所有核心功能完全免费。免费麻将游戏不下载、不安装，打开即玩。我们致力于为麻将爱好者提供最便捷的在线麻将体验。'
  },
  {
    question: '对电脑配置有要求吗？',
    answer: '麻将电脑版在线玩对电脑配置要求极低。只要是能够流畅运行浏览器的电脑，无论Windows还是Mac系统，都可以顺畅游戏。我们的网页麻将在线游戏采用了优化的技术方案，即使在配置较低的电脑上也能流畅运行。'
  },
  {
    question: '游戏数据会保存吗？',
    answer: '您的游戏记录和偏好设置会安全地保存在服务器上。无论您更换电脑还是清除浏览器缓存，只要登录同一账号，所有数据都会自动同步。'
  },
  {
    question: '如何提升麻将水平？',
    answer: '我们建议从以下方面入手：首先，在麻将单机版电脑中与AI对战练习基本功；其次，阅读我们网站上的攻略文章学习策略技巧；最后，通过多人联机实战积累经验。从新手到高手，麻将电脑版在线玩全程陪伴。'
  }
];

export const testimonials = [
  {
    name: '张先生',
    location: '北京',
    rating: 5,
    comment: '麻将电脑版在线玩真的太方便了！下班回家打开浏览器就能打几局，不用下载任何东西。经典麻将的规则还原得很好，界面也很清爽。推荐给了好几个同事，大家现在下班都线上约一局。'
  },
  {
    name: '李阿姨',
    location: '成都',
    rating: 5,
    comment: '我是四川人，特别喜欢打血流成河。这个网页麻将在线游戏的血流成河做得太地道了，胡牌后还能继续打的设定完全还原了线下玩法。现在每天下午都和姐妹们在线上搓两把，日子过得太安逸了。'
  },
  {
    name: '王同学',
    location: '广州',
    rating: 5,
    comment: '作为一名大学生，和室友经常一起打广东麻将。放假回家后，我们就用这个免费麻将游戏不下载的平台继续玩。网页版流畅不卡顿，而且番数计算很准确，再也不用为算番吵架了哈哈。'
  },
  {
    name: '陈先生',
    location: '上海',
    rating: 4,
    comment: '国标麻将爱好者，之前一直在找能认真打国标的在线平台。麻将电脑版在线玩的国标麻将81个番种齐全，规则严谨，非常适合想要提升竞技水平的玩家。如果能增加一些赛事功能就更好了。'
  },
  {
    name: '刘女士',
    location: '长沙',
    rating: 5,
    comment: '长沙麻将的二五八做将规则很独特，很多平台都没有。这里竟然有正宗的长沙麻将！扎鸟玩法也完全还原了，乡音麻将就是亲切。电脑麻将免费在线玩，随时随地过把瘾！'
  },
  {
    name: '周老先生',
    location: '杭州',
    rating: 5,
    comment: '退休后经常在麻将单机版电脑上打麻将，AI难度可以调节很适合我们老年人。界面字体很大，操作简单，孩子们也不用担心我下载到乱七八糟的软件。这个免费麻将游戏不下载不安装，真的是老年人的福音。'
  }
];

export const siteInfo = {
  name: '麻将电脑版在线玩',
  slogan: '免费经典麻将，打开浏览器立即开局',
  description: '麻将电脑版在线玩是专业的网页麻将在线游戏平台，提供经典麻将、血流成河、广东麻将、国标麻将、长沙麻将等多种免费麻将玩法。无需下载安装，支持单机练习与多人联机对战，是麻将爱好者最佳的电脑麻将免费在线玩选择。',
  founded: '2023年',
  users: '500,000+',
  games: '10,000,000+',
  categories: 6,
  address: '中国广东省深圳市南山区科技园',
  email: 'support@mahjong-online.com',
  phone: '400-888-麻将',
  wechat: 'mahjong_online',
  qq: '1234567890'
};